import { useState } from "react";
import { useTheme } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";
import { Button, useRefresh, useNotify, useUnselectAll } from "react-admin";

import { firestore } from "../../../init/firebase";
import { applyTimestamps } from "../../../utils/funcs";

const DisableClientButton = ({ selectedIds }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const [loading, setLoading] = useState();
  const theme = useTheme();
  const disableClient = async () => {
    try {
      setLoading(true);
      const batch = firestore.batch();
      Array.isArray(selectedIds) &&
        selectedIds.forEach((id) => {
          batch.update(
            firestore.collection("clients").doc(id),
            applyTimestamps({
              data: {
                disabled: true,
              },
              isUpdate: true,
            })
          );
        });
      await batch.commit();
      notify("Clients have been disabled", "success");
      unselectAll("clients");
      refresh();
      setLoading(false);
    } catch (ex) {
      console.log(ex.message);
      notify("Error on disable clients", "error");
      refresh();
      setLoading(false);
    }
  };

  return (
    <Button style={{ color: theme.palette.error.main }} label="Disable" disabled={loading} onClick={disableClient}>
      <BlockIcon color="error" />
    </Button>
  );
};

export default DisableClientButton;
